import React, { ReactNode, ComponentType } from 'react';

import { ProtectedRoute } from './ProtectedRoute';

interface ProtectedProps {
  children?: ReactNode;
}

// withProtectedRoute will check if user is logged in before
// rendering component or if they have a consent requirement
export function withProtectedRoute(WrappedComponent: ComponentType<any>) {
  const Protected = (props: ProtectedProps) => (
    <ProtectedRoute>
      <WrappedComponent {...props} />
    </ProtectedRoute>
  );

  return Protected;
}
